import { ProductDetailRoutes } from "src/constants/product-detail-routes";
import { AppRoutes } from "src/containers/app/constants/routes";
import { BurialRoutes } from "src/containers/burial/constants/routes";
import { EpsRoutes } from "src/containers/eps/core/routes";
import { HealthTravelerCarnetRoutes } from "src/containers/health-traveler-carnet/constants/routes";
import { HomeCardsRoutes } from "src/containers/home/constants/cards-routes";
import { HouseholdClaimRoutes } from "src/containers/household-claim/constants/routes";
import { InsurancesRoutes } from "src/containers/insurances/constants/routes";
import { LifeRoutes } from "src/containers/life/constants/routes";
import { RentalRoutes } from "src/containers/rental/constants/routes";
import { CrmRequestsRoutes } from "src/containers/requests/constants/routes";
import { VehicularAssistanceRoutes } from "src/containers/vehicular-assistance/constants/routes";
import { WellbeingRoutesV1 } from "src/containers/wellbeing/shared/constants/routes";
import { MedicineDeliveryRoutes } from "src/domains/medicine-delivery/constants/routes";
import { WellbeingRoutes } from "src/domains/wellbeing/constants/routes";

const CheckRoutes = {
    ...HomeCardsRoutes,
    ...InsurancesRoutes,
    ...AppRoutes,
    ...HealthTravelerCarnetRoutes,
    ...BurialRoutes,
    HealthTravelerCarnetRoutesRoot: HealthTravelerCarnetRoutes.Root,
    ...WellbeingRoutesV1,
    ...WellbeingRoutes,
    ...HouseholdClaimRoutes,
    HouseholdClaimRoutesRoot: HouseholdClaimRoutes.Root,
    HouseholdClaimRoutesDocumentsUpload: HouseholdClaimRoutes.DocumentsUpload,
    ...CrmRequestsRoutes,
    CrmRequestsRoutesRoot: CrmRequestsRoutes.Root,
    ...MedicineDeliveryRoutes,
    MedicineDeliveryRoutesRoot: MedicineDeliveryRoutes.Root,
    MedicineDeliveryRoutesLocationData: MedicineDeliveryRoutes.LocationData,
    MedicineDeliveryRoutesDocumentsUpload:
        MedicineDeliveryRoutes.DocumentsUpload,
    ...VehicularAssistanceRoutes,
    ...ProductDetailRoutes,
    ...LifeRoutes,
    ...EpsRoutes,
    ...RentalRoutes,
    RentalRoutesRoot: RentalRoutes.ROOT,
    ROUTE_REQUESTS_UPDATE_DATE:
        "/v1/#/inicio/solicitudes/registro/actualizacion-datos/otp",
    ROUTE_REQUESTS_UPDATE_DATE_OTP_VERIFY:
        "/v1/#/inicio/solicitudes/registro/actualizacion-datos/otp/verificacion",
    ROUTE_REQUESTS_UPDATE_COMPLETE:
        "/v1/#/inicio/solicitudes/registro/actualizacion-datos/otp/completo",
    ROUTE_SEARCH_TALLER_DETAIL: "/v1/#/autos/:plan/detalle-taller/:id",
    ROUTE_VEHICLE_MY_PAYMENTS:
        "/v1/#/autos/:productCode/mis-pagos/:systemCode/:policyId",
    ROUTE_VEHICLE_MY_POLICY_DETAIL:
        "/v1/#/autos/:productCode/detalle-poliza/:systemCode/:policyId",
    ROUTE_VEHICLE_COVERAGE_DETAIL:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId",
    ROUTE_VEHICLE_COVERAGE_DETAIL_DANOS:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/coberturas/danos",
    ROUTE_VEHICLE_COVERAGE_DETAIL_ROBO:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/coberturas/robo",
    ROUTE_VEHICLE_COVERAGE_DETAIL_ROTURA:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/coberturas/rotura-lunas",
    ROUTE_VEHICLE_COVERAGE_DETAIL_ACCIDENTES:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/coberturas/accidentes-personales",
    ROUTE_VEHICLE_COVERAGE_DETAIL_RESPONSABILIDAD:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/coberturas/responsabilidad-civil",
    ROUTE_VEHICLE_COVERAGE_DETAIL_ASISTENCIA:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/coberturas/asistencias",
    ROUTE_VEHICLE_EXCLUSIONS_USO:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/exclusiones/usos-no-declarados",
    ROUTE_VEHICLE_EXCLUSIONS_CIRCULACION:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/exclusiones/circulacion-vias-no-regulares",
    ROUTE_VEHICLE_EXCLUSIONS_FALTA:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/exclusiones/falta-reglamento-transito",
    ROUTE_VEHICLE_EXCLUSIONS_OTROS:
        "/v1/#/autos/:productCode/coberturas/:systemCode/:policyId/exclusiones/otros",
    ROUTE_VEHICLE_DOWNLOAD_POLICY:
        "/v1/#/autos/:productCode/poliza/:systemCode/:policyId/descargar",
    ROUTE_LIFE_COVERAGE_DEATH:
        "/mis-seguros/pga/vida/:productCode/coberturas/:systemCode/:policyId/cobertura/muerte-natural-vg110",
    ROUTE_LIFE_COVERAGE_DEATH_ACCIDENT:
        "/mis-seguros/pga/vida/:productCode/coberturas/:systemCode/:policyId/cobertura/muerte-accidental-vg110",
    ROUTE_LIFE_COVERAGE_INCAPACITY:
        "/mis-seguros/pga/vida/:productCode/coberturas/:systemCode/:policyId/cobertura/invalidez-total-permanente-accidental-vg110",
    ROUTE_EPS_DETAIL: "/v1/#/salud/EPS-R/detalle-plan/:planNumber",
    ROUTE_EPS_DOWNLOAD: "/v1/#/salud/EPS-R/plan/:planNumber/descargar",
    ROUTE_MORTGATE_DOWNLOAD:
        "/v1/#/pga/hipotecario/:productCode/descargar-documentos/:systemCode/:policyId",
    ROUTE_HEALTH_COVERAGE_DETAIL:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId",
    ROUTE_HEALTH_COVERAGE_DETAIL_TREATMENT:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId/coberturas/tratamientos-oncologicos",
    ROUTE_HEALTH_COVERAGE_DETAIL_SURGERY:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId/coberturas/cirugias-y-examenes",
    ROUTE_HEALTH_COVERAGE_DETAIL_CHECK:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId/coberturas/chequeo-preventivo",
    ROUTE_HEALTH_COVERAGE_DETAIL_ADDITIONAL_SERVICES:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId/coberturas/servicios-adicionales",
    ROUTE_HEALTH_COVERAGE_DETAIL_CANCER_SERVICES:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId/coberturas/servicios-de-la-red-aliada-contra-el-cancer",
    ROUTE_HEALTH_COVERAGE_DETAIL_INTERNATIONAL:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId/coberturas/internacional",
    ROUTE_HEALTH_EXCLUSION_MAIN:
        "/v1/#/salud/:productCode/coberturas/:systemCode/:policyId/exclusiones/principales-exclusiones",
    ROUTE_HEALTH_ACTIVE_INSURANCE:
        "/v1/#/salud/:productCode/poliza/:systemCode/:policyId/activacion-seguro",
    ROUTE_HEALTH_MY_PAYMENTS:
        "/v1/#/salud/:productCode/mis-pagos/:systemCode/:policyId",
    ROUTE_HEALTH_DOWNLOAD:
        "/v1/#/salud/:productCode/poliza/:systemCode/:policyId/descargar",
    ROUTE_ACCIDENTES_COVERAGE_DETAIL:
        "/V1/#/pga/accidentes/:productCode/coberturas/:systemCode/:policyId/coberturas",
    ROUTE_ACCIDENTES_COVERAGE_DETAIL_DEATH:
        "/V1/#/pga/Accidentes/:productCode/coberturas/:systemCode/:policyId/coberturas/muerte-accidental",
    ROUTE_ACCIDENTES_COVERAGE_DETAIL_INCAPACITY:
        "/V1/#/pga/Accidentes/:productCode/coberturas/:systemCode/:policyId/coberturas/invalidez-permanente",
    ROUTE_ACCIDENTES_MY_PAYMENTS:
        "/V1/#/pga/accidentes/:productCode/mis-pagos/:systemCode/:policyId",
    ROUTE_LIFE_MY_PAYMENTS:
        "/v1/#/pga/vida/:productCode/mis-pagos/:systemCode/:policyId",
    ROUTE_LIFE_DETAIL:
        "/v1/#/pga/vida/:productCode/detalle-poliza/:systemCode/:policyId",
    ROUTE_LIFE_COVERAGE_DETAIL:
        "/v1/#/pga/vida/:productCode/coberturas/:systemCode/:policyId",
    ROUTE_LIFE_EXCLUSION_DISEASE:
        "/v1/#/pga/vida/:productCode/coberturas/:systemCode/:policyId/exclusiones/enfermedades-preexistentes",
    ROUTE_LIFE_EXCLUSION_DANGEROUS:
        "/v1/#/pga/vida/:productCode/coberturas/:systemCode/:policyId/exclusiones/profesiones-peligrosas-y-deportes-de-alto-riesgo",
    ROUTE_LIFE_EXCLUSION_WAR:
        "/v1/#/pga/vida/:productCode/coberturas/:systemCode/:policyId/exclusiones/guerra",
    ROUTE_LIFE_EXCLUSION_UNLAWFUL:
        "/v1/#/pga/vida/:productCode/coberturas/:systemCode/:policyId/exclusiones/actos-ilicitos",
    ROUTE_LIFE_EXCLUSION_USE_DRUGS:
        "/v1/#/pga/vida/:productCode/coberturas/:systemCode/:policyId/exclusiones/uso-de-drogas",
    ROUTE_LIFE_EXCLUSION_SUICIDE:
        "/v1/#/pga/vida/:productCode/coberturas/:systemCode/:policyId/exclusiones/suicidio",
    ROUTE_SOAT_COVERAGE_DETAIL:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId",
    ROUTE_SOAT_COVERAGE_DETAIL_HEALTH_CARE:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/coberturas/atencion-medica",
    ROUTE_SOAT_COVERAGE_DETAIL_INCAPACITY:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/coberturas/incapacidad-temporal-o-invalidez",
    ROUTE_SOAT_COVERAGE_DETAIL_BURIAL:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/coberturas/gastos-de-sepelio-y-muerte",
    ROUTE_SOAT_EXCLUSION_RACING:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/exclusiones/carreras-de-automoviles",
    ROUTE_SOAT_EXCLUSION_ACCIDENT:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/exclusiones/accidentes-en-el-extranjero",
    ROUTE_SOAT_EXCLUSION_ACCIDENT_PUBLIC:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/exclusiones/accidentes-en-lugares-no-publicos",
    ROUTE_SOAT_EXCLUSION_SITUATIONS:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/exclusiones/guerras-sismos-y-casos-fortuitos",
    ROUTE_SOAT_EXCLUSION_SUICIDE:
        "/v1/#/soat/:productCode/coberturas/:systemCode/:policyId/exclusiones/suicidio-y-lesiones-autoinferidas",
    ROUTE_RENTA_COVERAGE_DETAIL_MEDICAL:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/renta-vitalicia-mensual",
    ROUTE_RENTA_COVERAGE_DETAIL_MEDICAL_MONTH:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/renta-mensual",
    ROUTE_RENTA_COVERAGE_DETAIL_COSTS:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/gastos-sepelio",
    ROUTE_RENTA_COVERAGE_RETURN_PREMIUM:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/devolucion-prima",
    ROUTE_RENTA_COVERAGE_DETAIL_COSTS_FLEX:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/gastos-sepelio-flex",
    ROUTE_RENTA_COVERAGE_ACCIDENTAL_DEATH:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/cobertura-muerte-accidental",
    ROUTE_RENTA_COVERAGE_LIFE:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/cobertura/cobertura-vida",
    ROUTE_RENTA_EXCLUSION_DETAIL_SITUATIONS:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/exclusion/guerra",
    ROUTE_RENTA_EXCLUSION_DETAIL_ACTOS:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/exclusion/actos-ilicitos",
    ROUTE_RENTA_EXCLUSION_DETAIL_USE:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/exclusion/uso-drogas",
    ROUTE_RENTA_EXCLUSION_DETAIL_SUICIDIO:
        "/mis-seguros/pga/rentas/:productCode/coberturas/:systemCode/:policyId/exclusion/suicidio",
    ROUTE_RENTA_INVERSION:
        "/mis-seguros/pga/rentas/:productCode/inversiones/:systemCode/:policyId",
    ROUTE_BURIAL_DETAIL:
        "/mis-seguros/pga/sepelio/:productCode/detalle-poliza/:systemCode/:policyId",
    ROUTE_BURIAL_COVERAGE_DETAIL:
        "/mis-seguros/pga/sepelio/:productCode/coberturas/:systemCode/:policyId",
    ROUTE_BURIAL_MY_PAYMENTS:
        "/v1/#/pga/sepelio/:productCode/mis-pagos/:systemCode/:policyId",
    ROUTE_HOUSE_DETAIL:
        "/v1/#/pga/hogar/:productCode/detalle-poliza/:systemCode/:policyId",
    ROUTE_HOUSE_MY_PAYMENTS:
        "/v1/#/pga/hogar/:productCode/mis-pagos/:systemCode/:policyId",
    ROUTE_HOUSE_DOCUMENTS:
        "/v1/#/pga/hogar/:productCode/descargar-documentos/:systemCode/:policyId",
    ROUTE_HOUSE_BOOKING: "/siniestros/hogar/reserva#/?goToV2=false",
    ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS:
        "/v1/#/pga/hogar/:productCode/mis-pagos/:systemCode/:policyId/instructivo",
    ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS:
        "/v1/#/pga/sepelio/:productCode/mis-pagos/:systemCode/:policyId/instructivo",
    ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS:
        "/v1/#/pga/vida/:productCode/mis-pagos/:systemCode/:policyId/instructivo",
    ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS:
        "/v1/#/pga/accidentes/:productCode/mis-pagos/:systemCode/:policyId/instructivo",
    ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS:
        "/v1/#/salud/:productCode/mis-pagos/:systemCode/:policyId/instructivo",
    ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS:
        "/v1/#/autos/:productCode/mis-pagos/:systemCode/:policyId/instructivo",
    ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_BCP:
        "/v1/#/pga/hogar/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bcp",
    ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_BCP:
        "/v1/#/pga/sepelio/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bcp",
    ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_BCP:
        "/v1/#/pga/vida/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bcp",
    ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_BCP:
        "/v1/#/pga/accidentes/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bcp",
    ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_BCP:
        "/v1/#/salud/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bcp",
    ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS_BCP:
        "/v1/#/autos/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bcp",
    ROUTE_MY_PAYMENTS_INSTRUCTIONS_BCP:
        "/v1/#/inicio/mis-pagos/instructivo/bcp",
    ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_BBVA:
        "/v1/#/pga/hogar/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bbva",
    ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_BBVA:
        "/v1/#/pga/sepelio/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bbva",
    ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_BBVA:
        "/v1/#/pga/vida/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bbva",
    ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_BBVA:
        "/v1/#/pga/accidentes/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bbva",
    ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_BBVA:
        "/v1/#/salud/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bbva",
    ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS_BBVA:
        "/v1/#/autos/:productCode/mis-pagos/:systemCode/:policyId/instructivo/bbva",
    ROUTE_MY_PAYMENTS_INSTRUCTIONS_BBVA:
        "/v1/#/inicio/mis-pagos/instructivo/bbva",
    ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_INTERBANK:
        "/v1/#/pga/hogar/:productCode/mis-pagos/:systemCode/:policyId/instructivo/interbank",
    ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_INTERBANK:
        "/v1/#/pga/sepelio/:productCode/mis-pagos/:systemCode/:policyId/instructivo/interbank",
    ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_INTERBANK:
        "/v1/#/pga/vida/:productCode/mis-pagos/:systemCode/:policyId/instructivo/interbank",
    ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_INTERBANK:
        "/v1/#/pga/accidentes/:productCode/mis-pagos/:systemCode/:policyId/instructivo/interbank",
    ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_INTERBANK:
        "/v1/#/salud/:productCode/mis-pagos/:systemCode/:policyId/instructivo/interbank",
    ROUTE_MY_PAYMENTS_INSTRUCTIONS_INTERBANK:
        "/v1/#/inicio/mis-pagos/instructivo/interbank",
    ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK:
        "/v1/#/pga/hogar/:productCode/mis-pagos/:systemCode/:policyId/instructivo/scotiabank",
    ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK:
        "/v1/#/pga/sepelio/:productCode/mis-pagos/:systemCode/:policyId/instructivo/scotiabank",
    ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK:
        "/v1/#/pga/vida/:productCode/mis-pagos/:systemCode/:policyId/instructivo/scotiabank",
    ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK:
        "/v1/#/pga/accidentes/:productCode/mis-pagos/:systemCode/:policyId/instructivo/scotiabank",
    ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK:
        "/v1/#/salud/:productCode/mis-pagos/:systemCode/:policyId/instructivo/scotiabank",
    ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK:
        "/v1/#/autos/:productCode/mis-pagos/:systemCode/:policyId/instructivo/scotiabank",
    ROUTE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK:
        "/v1/#/inicio/mis-pagos/instructivo/scotiabank",
    ROUTE_DEBIT_AUTOMATIC_PAYMENT:
        "/v1/#/inicio/solicitudes/registro/afiliacion-debito?params",
    ROUTE_DEBIT_AUTOMATIC_PAYMENT_OTP:
        "/v1/#/inicio/solicitudes/registro/afiliacion-debito/otp",
    ROUTE_DEBIT_AUTOMATIC_PAYMENT_VERIFY_OTP:
        "/v1/#/inicio/solicitudes/registro/afiliacion-debito/otp/verificacion",
    ROUTE_DEBIT_AUTOMATIC_PAYMENT_COMPLETE_OTP:
        "/v1/#/inicio/solicitudes/registro/afiliacion-debito/otp/completo",
    ROUTE_MY_PAYMENTS_INSTRUCTIONS: "/v1/#/inicio/mis-pagos/instructivo",
};

export class GtmPageViewService {
    static getLocationPage(url?: string): string {
        return url || window.location.href.split(window.location.origin)[1];
    }

    static getPageParameters(url?: string): Record<string, string> {
        let pageTitle = "";
        let classPage = "";
        const pageLocation = GtmPageViewService.getLocationPage(url);
        const simpleRegex = (route: string) => new RegExp(`^${route}$`);
        const paramsRegex = (route: string) => {
            // eslint-disable-next-line
            const regex_a = route.replace(/\/\:[^\/]+/g, "/[^/]+");
            const regex_b = regex_a.replace(/\?.*/g, "?.*");
            return new RegExp(`^${regex_b}$`);
        };
        const verifyRoute = (route: string, containsParams = false) =>
            containsParams
                ? paramsRegex(route).test(pageLocation)
                : simpleRegex(route).test(pageLocation);
        switch (true) {
            case verifyRoute(CheckRoutes.ROUTE_DEFAULT):
            case verifyRoute(CheckRoutes.ROUTE_HOME):
                classPage = "Home:Home:Home";
                pageTitle = "Home";
                break;
            case verifyRoute(CheckRoutes.ROUTE_TERMS_CONDITIONS):
                classPage =
                    "TerminosYCondiciones:TerminosYCondiciones:TerminosYCondiciones";
                pageTitle = "Terminos y condiciones";
                break;
            case verifyRoute(CheckRoutes.ROUTE_DOCUMENTS_DOWNLOAD):
                classPage = "HomeTabsPrincipales:DescargaPoliza:Poliza";
                pageTitle = "Descargar documentos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_INSURANCES_OVERVIEW):
                classPage = "Seguros:Inicio:Inicio";
                pageTitle = "Mis seguros";
                break;
            case verifyRoute(CheckRoutes.ROUTE_CLIENT_INFORMATION):
                classPage = "MisDatos:VisualizarMisDatos:VerDatos";
                pageTitle = "Mis datos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_CLIENT_INFORMATION_UPDATE):
                classPage = "MisDatos:EditarMisDatos:ActualizacionDatos";
                pageTitle = "Mis datos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_SUMARY_PAYMENTS):
                classPage = "HomeTabsPrincipales:MisPagos";
                pageTitle = "Mis pagos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_DIGITAL_POLICY):
                classPage = "PolizaDigital:VerPolizaDigital:VerPoliza";
                pageTitle = "Mi poliza";
                break;
            case verifyRoute(CheckRoutes.ROUTE_V1_PGA_PAYMENTS, true):
                classPage = "HomeTabsPrincipales:MisPagos";
                pageTitle = "Mi pagos";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_V1_PGA_COBERAGES_EXCLUSIONS,
                true
            ):
                classPage = "ProteccionTarjeta:Inicio";
                pageTitle = "Protección de tarjeta";
                break;
            case verifyRoute(CheckRoutes.ROUTE_REQUESTS_UPDATE_DATE, true):
                classPage = "MisDatos:EditarMisDatos:SolicitudCodigo";
                pageTitle = "Actualizacion de datos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_REQUESTS_UPDATE_DATE_OTP_VERIFY):
                classPage =
                    "MisDatos:EditarMisDatos:ValidacionCodigo:Verficacion";
                pageTitle = "Actualizacion de datos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_REQUESTS_UPDATE_COMPLETE):
                classPage = "MisDatos:EditarMisDatos:SolicitudEnviada";
                pageTitle = "Actualizacion de datos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_AFTER_OTP_COMPLETE):
                classPage = "SolicitudRegistro:Completado";
                pageTitle = "Solicitud de registro";
                break;
            case verifyRoute(CheckRoutes.ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_OK):
                classPage = "PasarelaPago:Inicio";
                pageTitle = "Pasarela de pago";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_ERROR
            ):
            case verifyRoute(
                CheckRoutes.V1_ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_ERROR
            ):
                classPage = "PasarelaPago:Error";
                pageTitle = "Pasarela de pago";
                break;
            case verifyRoute(
                CheckRoutes.V1_ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_OK
            ):
                classPage = "PasarelaPago:Exitoso";
                pageTitle = "Pasarela de pago";
                break;
            case verifyRoute(CheckRoutes.HealthTravelerCarnetRoutesRoot):
            case verifyRoute(CheckRoutes.CarnetList, true):
            case verifyRoute(CheckRoutes.CarnetDetail, true):
                classPage = "HomeTabsAsistencias:CarnetSalud:Inicio";
                pageTitle = "Carnet de salud";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_WELLBEING_DISCOUNTS_MULTIVENTAJASPLUS
            ):
                classPage = "Beneficios:MultiventajasPlus:DetalleDeBeneficio";
                pageTitle = "Beneficios";
                break;
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_DISCOUNTS_ETNA):
                classPage = "Beneficios:BateriasETNA:DetalleDeBeneficio";
                pageTitle = "Beneficios";
                break;
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING):
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_DISCOUNTS):
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_DISCOUNTS_CLEANING):
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_DISCOUNTS_MAINTENANCE):
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_DISCOUNTS_ACCESORIES):
            case verifyRoute(
                CheckRoutes.ROUTE_WELLBEING_DISCOUNTS_TECHNICAL_INSPECTION
            ):
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_SERVICES):
            case verifyRoute(
                CheckRoutes.ROUTE_WELLBEING_SERVICES_HEALTH_AT_HOME
            ):
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_REWARDS):
            case verifyRoute(CheckRoutes.ROUTE_WELLBEING_SCRATCH_GAME, true):
                classPage = "Beneficios:ListaBeneficios:Inicio";
                pageTitle = "Beneficios";
                break;
            case verifyRoute(CheckRoutes.HouseholdClaimRoutesRoot):
            case verifyRoute(CheckRoutes.Booking):
            case verifyRoute(CheckRoutes.DeclarationOfAssets):
            case verifyRoute(CheckRoutes.BookingDamage):
            case verifyRoute(CheckRoutes.BookingPending):
            case verifyRoute(CheckRoutes.BookingDone, true):
                classPage = "Siniestros:Hogar:Inicio";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.Registration, true):
                classPage = "Siniestros:Hogar:Registro:Inicio";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(
                CheckRoutes.HouseholdClaimRoutesDocumentsUpload,
                true
            ):
                classPage = "Siniestros:Hogar:Registro:Documentos";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.AccountData, true):
                classPage = "Siniestros:Hogar:Registro:Datos";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.RegisterDone, true):
                classPage = "Siniestros:Hogar:Registro:Finalizar";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.Results, true):
                classPage = "Siniestros:Hogar:Proceso:Resultado";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.EvaluationResults, true):
                classPage = "Siniestros:Hogar:Proceso:Evaluacion";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.CompensationApproved, true):
                classPage = "Siniestros:Hogar:Proceso:ResumenAprobacion";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.AdjusterSelection, true):
                classPage = "Siniestros:Hogar:Proceso:Adjuntar";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.AdjusterDone, true):
                classPage = "Siniestros:Hogar:Proceso:Terminado";
                pageTitle = "Sinestros Hogar";
                break;
            case verifyRoute(CheckRoutes.CrmRequestsRoutesRoot):
                classPage = "Mis Solicitudes:Inicio";
                pageTitle = "Mis solicitudes";
                break;
            case verifyRoute(CheckRoutes.MedicineDeliveryRoutesRoot):
                classPage = "HomeTabsAsistencias:DeliveryMedicamentos:Inicio";
                pageTitle = "Delivery de medicamentos";
                break;
            case verifyRoute(CheckRoutes.BasicData):
                classPage = "HomeTabsAsistencias:DeliveryMedicamentos:Paso1";
                pageTitle = "Delivery de medicamentos";
                break;
            case verifyRoute(CheckRoutes.MedicineDeliveryRoutesLocationData):
                classPage = "HomeTabsAsistencias:DeliveryMedicamentos:Paso2";
                pageTitle = "Delivery de medicamentos";
                break;
            case verifyRoute(CheckRoutes.MedicineDeliveryRoutesDocumentsUpload):
                classPage = "HomeTabsAsistencias:DeliveryMedicamentos:Paso3";
                pageTitle = "Delivery de medicamentos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_VEHICLES_MAP):
                classPage =
                    "HomeTabsAsistencias:BuscarTalleres:CatalogoTalleres";
                pageTitle = "Buscar talleres";
                break;
            case verifyRoute(CheckRoutes.ROUTE_SEARCH_TALLER_DETAIL, true):
                classPage =
                    "HomeTabsAsistencias:BuscarTalleres:AlmacenSeleccionado";
                pageTitle = "Buscar talleres";
                break;
            case verifyRoute(CheckRoutes.VEHICLES, true):
                classPage = "Seguros:SeguroAutos:Paso1:Detalle";
                pageTitle = "SeguroAutos";
                break;
            case verifyRoute(CheckRoutes.ROUTE_VEHICLE_COVERAGE_DETAIL, true):
                classPage = "Seguros:SeguroAutos:Paso2:CoberturasExclusiones";
                pageTitle = "SeguroAutosPaso2";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_COVERAGE_DETAIL_DANOS,
                true
            ):
                classPage = "Seguros:SeguroAutos:Paso3:Danos";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_COVERAGE_DETAIL_ROBO,
                true
            ):
                classPage = "Seguros:SeguroAutos:Paso3:Robo";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_COVERAGE_DETAIL_ROTURA,
                true
            ):
                classPage = "Seguros:SeguroAutos:Paso3:RoturaLuna";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_COVERAGE_DETAIL_ACCIDENTES,
                true
            ):
                classPage = "Seguros:SeguroAutos:Paso3:AccidentesPersonales";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_COVERAGE_DETAIL_RESPONSABILIDAD,
                true
            ):
                classPage = "Seguros:SeguroAutos:Paso3:ResponsabilidadCivil";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_COVERAGE_DETAIL_ASISTENCIA,
                true
            ):
                classPage = "Seguros:SeguroAutos:Paso3:Asistencias";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_VEHICLE_EXCLUSIONS_USO, true):
                classPage = "Seguros:SeguroAutos:Paso3:UsosNoDeclarados";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_EXCLUSIONS_CIRCULACION,
                true
            ):
                classPage =
                    "Seguros:SeguroAutos:Paso3:CirculacionViasNoRegulares";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_VEHICLE_EXCLUSIONS_FALTA, true):
                classPage = "Seguros:SeguroAutos:Paso3:FaltaReglamentoTransito";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_VEHICLE_EXCLUSIONS_OTROS, true):
                classPage = "Seguros:SeguroAutos:Paso3:Otros";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_VEHICLE_DOWNLOAD_POLICY, true):
                classPage = "Seguros:SeguroAutos:Paso3:Descargar";
                pageTitle = "SeguroAutosPaso3";
                break;
            case verifyRoute(CheckRoutes.StartRequestBasicData):
                classPage =
                    "HomeTabsAsistencias:AsistenciaVehicular:ElegirVehiculo";
                pageTitle = "Asistencia Vehicular";
                break;
            case verifyRoute(CheckRoutes.StartRequestGeolocation):
                classPage =
                    "HomeTabsAsistencias:AsistenciaVehicular:ElegirTipoAsistencia";
                pageTitle = "Asistencia Vehicular";
                break;
            case verifyRoute(CheckRoutes.TireChange):
                classPage =
                    "HomeTabsAsistencias:AsistenciaVehicular:CambioLlanta";
                pageTitle = "Asistencia Vehicular";
                break;
            case verifyRoute(CheckRoutes.BatteryRecharge):
                classPage =
                    "HomeTabsAsistencias:AsistenciaVehicular:RecargaBateria";
                pageTitle = "Asistencia Vehicular";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_DETAIL, true):
            case verifyRoute(CheckRoutes.InsuranceDetail, true):
                classPage = "Seguros:SeguroVida:Paso1:Detalle";
                pageTitle = "SeguroVida";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_COVERAGE_DETAIL, true):
            case verifyRoute(CheckRoutes.InsuranceCoverages, true):
                classPage = "Seguros:SeguroVida:Paso2:CoberturasExclusiones";
                pageTitle = "SeguroVidaPaso2";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_COVERAGE_DEATH, true):
                classPage = "Seguros:SeguroVida:Paso3:MuerteNatural";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_LIFE_COVERAGE_DEATH_ACCIDENT,
                true
            ):
                classPage = "Seguros:SeguroVida:Paso3:MuerteAccidental";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_COVERAGE_INCAPACITY, true):
                classPage = "Seguros:SeguroVida:Paso3:InvalidezTotal";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_EPS_DETAIL, true):
                classPage = "Seguros:SeguroEPS:Paso1:Detalle";
                pageTitle = "SeguroEPS";
                break;
            case verifyRoute(CheckRoutes.ROUTE_EPS_DOWNLOAD, true):
                classPage = "Seguros:SeguroEPS:Paso3:Descargar";
                pageTitle = "SeguroEPSPaso3";
                break;
            case verifyRoute(CheckRoutes.MORTGATE, true):
                classPage = "Seguros:SeguroHipotecario:Paso1:Detalle";
                pageTitle = "SeguroHipotecario";
                break;
            case verifyRoute(CheckRoutes.ROUTE_MORTGATE_DOWNLOAD, true):
                classPage = "Seguros:SeguroHipotecario:Paso3:Descargar";
                pageTitle = "SeguroHipotecarioPaso3";
                break;
            case verifyRoute(CheckRoutes.HEALTH, true):
                classPage = "Seguros:SeguroSalud:Paso1:Detalle";
                pageTitle = "SeguroSalud";
                break;
            case verifyRoute(CheckRoutes.ROUTE_HEALTH_COVERAGE_DETAIL, true):
                classPage = "Seguros:SeguroSalud:Paso2:CoberturasExclusiones";
                pageTitle = "SeguroSaludPaso2";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_COVERAGE_DETAIL_TREATMENT,
                true
            ):
                classPage = "Seguros:SeguroSalud:Paso3:TratamientosOncologicos";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_COVERAGE_DETAIL_SURGERY,
                true
            ):
                classPage = "Seguros:SeguroSalud:Paso3:CirugiasYExamenes";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_COVERAGE_DETAIL_CHECK,
                true
            ):
                classPage = "Seguros:SeguroSalud:Paso3:ChequeoPreventivo";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_COVERAGE_DETAIL_ADDITIONAL_SERVICES,
                true
            ):
                classPage = "Seguros:SeguroSalud:Paso3:ServiciosAdicionales";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_COVERAGE_DETAIL_CANCER_SERVICES,
                true
            ):
                classPage = "Seguros:SeguroSalud:Paso3:RedAliadaContraCancer";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_COVERAGE_DETAIL_INTERNATIONAL,
                true
            ):
                classPage = "Seguros:SeguroSalud:Paso3:Internacional";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_HEALTH_EXCLUSION_MAIN, true):
                classPage = "Seguros:SeguroSalud:Paso3:PrincipalesExclusiones";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_HEALTH_ACTIVE_INSURANCE, true):
                classPage = "Seguros:SeguroSalud:Paso3:ComoActivarSeguro";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_HEALTH_DOWNLOAD, true):
                classPage = "DescargaTuPoliza";
                pageTitle = "SeguroSaludPaso3";
                break;
            case verifyRoute(CheckRoutes.ACCIDENTES, true):
                classPage = "Seguros:SeguroAccidentes:Paso1:Detalle";
                pageTitle = "SeguroAccidentes";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_COVERAGE_DETAIL,
                true
            ):
                classPage =
                    "Seguros:SeguroAccidentes:Paso2:CoberturasExclusiones";
                pageTitle = "SeguroAccidentesPaso2";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_COVERAGE_DETAIL_DEATH,
                true
            ):
                classPage = "Seguros:SeguroAccidentes:Paso3:MuerteAccidental";
                pageTitle = "SeguroAccidentesPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_COVERAGE_DETAIL_INCAPACITY,
                true
            ):
                classPage =
                    "Seguros:SeguroAccidentes:Paso3:InvalidezPermanente";
                pageTitle = "SeguroAccidentesPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_EXCLUSION_DISEASE, true):
                classPage = "Seguros:SeguroVida:Paso3:EnfermedadPreexistente";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_EXCLUSION_DANGEROUS, true):
                classPage = "Seguros:SeguroVida:Paso3:ProfesionesRiesgosas";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_EXCLUSION_WAR, true):
                classPage = "Seguros:SeguroVida:Paso3:Guerra";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_EXCLUSION_UNLAWFUL, true):
                classPage = "Seguros:SeguroVida:Paso3:ActosIlícitos";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_EXCLUSION_USE_DRUGS, true):
                classPage = "Seguros:SeguroVida:Paso3:UsoDrogas";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_LIFE_EXCLUSION_SUICIDE, true):
                classPage = "Seguros:SeguroVida:Paso3:Suicidio";
                pageTitle = "SeguroVidaPaso3";
                break;
            case verifyRoute(CheckRoutes.SOAT, true):
                classPage = "Seguros:SeguroSOAT:Paso1:Detalle";
                pageTitle = "SeguroSOAT";
                break;
            case verifyRoute(CheckRoutes.ROUTE_SOAT_COVERAGE_DETAIL, true):
                classPage = "Seguros:SeguroSOAT:Paso2:CoberturasExclusiones";
                pageTitle = "SeguroSOATPaso2";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_SOAT_COVERAGE_DETAIL_HEALTH_CARE,
                true
            ):
                classPage = "Seguros:SeguroSOAT:Paso3:AtencionMedica";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_SOAT_COVERAGE_DETAIL_INCAPACITY,
                true
            ):
                classPage = "Seguros:SeguroSOAT:Paso3:IncapacidadTemporal";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_SOAT_COVERAGE_DETAIL_BURIAL,
                true
            ):
                classPage = "Seguros:SeguroSOAT:Paso3:GastosSepelio";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_SOAT_EXCLUSION_RACING, true):
                classPage = "Seguros:SeguroSOAT:Paso3:CarrerasAutomoviles";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_SOAT_EXCLUSION_ACCIDENT, true):
                classPage = "Seguros:SeguroSOAT:Paso3:AccidentesExtranjero";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_SOAT_EXCLUSION_ACCIDENT_PUBLIC,
                true
            ):
                classPage = "Seguros:SeguroSOAT:Paso3:AccidentesNoPublicos";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_SOAT_EXCLUSION_SITUATIONS, true):
                classPage =
                    "Seguros:SeguroSOAT:Paso3:GuerrasSismosCasosFortuitos";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_SOAT_EXCLUSION_SUICIDE, true):
                classPage = "Seguros:SeguroSOAT:Paso3:SuicidioLesiones";
                pageTitle = "SeguroSOATPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_INSURANCE_POLICY_DETAIL, true):
                classPage = "Seguros:SeguroRenta:Paso1:Detalle";
                pageTitle = "SeguroRenta";
                break;
            case verifyRoute(CheckRoutes.ROUTE_INSURANCE_COVERAGES, true):
                classPage = "Seguros:SeguroRentas:Paso2:CoberturasExclusiones";
                pageTitle = "SeguroRentasPaso2";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_COVERAGE_DETAIL_MEDICAL,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:RentaVitaliciaMensual";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_COVERAGE_DETAIL_MEDICAL_MONTH,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:RentaMensual";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_COVERAGE_DETAIL_COSTS_FLEX,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_COVERAGE_DETAIL_COSTS,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:GastosSepelio";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_COVERAGE_RETURN_PREMIUM,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:DevolucionPrima";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_COVERAGE_ACCIDENTAL_DEATH,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:MuerteAccidental";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_RENTA_COVERAGE_LIFE, true):
                classPage = "Seguros:SeguroRentas:Paso3:CoberturaVida";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_EXCLUSION_DETAIL_SITUATIONS,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:Guerra";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_EXCLUSION_DETAIL_ACTOS,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:ActosIlicitos";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_EXCLUSION_DETAIL_USE,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:UsoDrogas";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_RENTA_EXCLUSION_DETAIL_SUICIDIO,
                true
            ):
                classPage = "Seguros:SeguroRentas:Paso3:Suicidio";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_RENTA_INVERSION, true):
                classPage = "Seguros:SeguroRentas:Paso3:Mensualidades";
                pageTitle = "SeguroRentasPaso3";
                break;
            case verifyRoute(CheckRoutes.ROUTE_BURIAL_DETAIL, true):
                classPage = "Seguros:SeguroSepelio:Paso1:Detalle";
                pageTitle = "SeguroSepelio";
                break;
            case verifyRoute(CheckRoutes.ROUTE_BURIAL_COVERAGE_DETAIL, true):
                classPage =
                    "Seguros:SeguroSepelio:Paso2:MisPrincipalesCoberturas";
                pageTitle = "SeguroSepelio";
                break;
            case verifyRoute(CheckRoutes.ROUTE_HOUSE_DETAIL, true):
                classPage = "Seguros:SeguroHogar:Paso1:Detalle";
                pageTitle = "SeguroHogar";
                break;
            case verifyRoute(CheckRoutes.ROUTE_HOUSE_DOCUMENTS, true):
                classPage = "Seguros:SeguroHogar:Paso3:SeleccionarDescarga";
                pageTitle = "SeguroHogar";
                break;
            case verifyRoute(CheckRoutes.ROUTE_HOUSE_BOOKING, true):
                classPage = "Seguros:SeguroHogar:Paso3:RegistroSiniestro";
                pageTitle = "SeguroHogar";
                break;
            case verifyRoute(CheckRoutes.REQUESTS_TRACKING):
                classPage = "HomeTabsPrincipales:SeguimientoTramites:Inicio";
                pageTitle = "Seguimiento Tramites";
                break;
            case verifyRoute(CheckRoutes.ROUTE_PAYMENTS):
            case verifyRoute(CheckRoutes.ROUTE_VEHICLE_MY_POLICY_DETAIL, true):
            case verifyRoute(CheckRoutes.ROUTE_VEHICLE_MY_PAYMENTS, true):
            case verifyRoute(CheckRoutes.ROUTE_HEALTH_MY_PAYMENTS, true):
            case verifyRoute(CheckRoutes.ROUTE_ACCIDENTES_MY_PAYMENTS, true):
            case verifyRoute(CheckRoutes.ROUTE_LIFE_MY_PAYMENTS, true):
            case verifyRoute(CheckRoutes.ROUTE_BURIAL_MY_PAYMENTS, true):
            case verifyRoute(CheckRoutes.ROUTE_HOUSE_MY_PAYMENTS, true):
                classPage = "MisPagos:VerDetalle";
                pageTitle = "MisPagos";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS,
                true
            ):
            case verifyRoute(CheckRoutes.ROUTE_MY_PAYMENTS_INSTRUCTIONS):
                classPage = "MisPagos:DondeYComoPagar:Inicio";
                pageTitle = "MisPagos";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_BCP,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_BCP,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_BCP,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_BCP,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_BCP,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS_BCP,
                true
            ):
            case verifyRoute(CheckRoutes.ROUTE_MY_PAYMENTS_INSTRUCTIONS_BCP):
                classPage =
                    "MisPagos:DondeYComoPagar:Instructivo:InstruccionesPagoBCP";
                pageTitle = "MisPagos";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_BBVA,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_BBVA,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_BBVA,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_BBVA,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_BBVA,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS_BBVA,
                true
            ):
            case verifyRoute(CheckRoutes.ROUTE_MY_PAYMENTS_INSTRUCTIONS_BBVA):
                classPage = "MisPagos:DondeYComoPagar:Instructivo:BBVA";
                pageTitle = "MisPagos";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_INTERBANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_INTERBANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_INTERBANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_INTERBANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_INTERBANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_MY_PAYMENTS_INSTRUCTIONS_INTERBANK
            ):
                classPage = "MisPagos:DondeYComoPagar:Instructivo:Interbank";
                pageTitle = "MisPagos";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_HOUSE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_BURIAL_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_LIFE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_ACCIDENTES_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_HEALTH_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_VEHICLE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK,
                true
            ):
            case verifyRoute(
                CheckRoutes.ROUTE_MY_PAYMENTS_INSTRUCTIONS_SCOTIABANK
            ):
                classPage = "MisPagos:DondeYComoPagar:Instructivo:Scotiabank";
                pageTitle = "MisPagos";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_DEBIT_AUTOMATIC_PAYMENT_COMPLETE_OTP
            ):
                classPage = "MisPagos:AfiliacionDebito:SolicitudRegistrada";
                pageTitle = "Afiliación al débito";
                break;
            case verifyRoute(
                CheckRoutes.ROUTE_DEBIT_AUTOMATIC_PAYMENT_VERIFY_OTP
            ):
                classPage = "MisPagos:AfiliacionDebito:ValidacionCodigo";
                pageTitle = "Afiliación al débito";
                break;
            case verifyRoute(CheckRoutes.ROUTE_DEBIT_AUTOMATIC_PAYMENT_OTP):
                classPage = "MisPagos:AfiliacionDebito:SolicitudCodigo";
                pageTitle = "Afiliación al débito";
                break;
            case verifyRoute(CheckRoutes.ROUTE_DEBIT_AUTOMATIC_PAYMENT, true):
                classPage = "MisPagos:AfiliacionDebito:Inicio";
                pageTitle = "Afiliación al débito";
                break;
        }
        return {
            pageTitle,
            classPage,
            pageLocation: `${window.location.origin}${pageLocation}`,
        };
    }
}
